import { Immutable } from "immer";
import React from "react";

type Props = Immutable<{ value: string }>;

/**
 * HiddenAnchorLinkBlock renders an invisible anchor target (`<span id={value}>`)
 * used for in-page navigation. Ported from the former pillows Django template.
 *
 * The underlying `HiddenAnchorLinkBlock` is a `RegexBlock` (effectively a
 * validated `CharBlock`), so the value is a plain string. Reactivated does not
 * generate a dedicated newtype for it because the block is pillows-specific and
 * type codegen runs through tsi-tempurpedic. Wave E will wire this component
 * into the shared Toolbox assembly when `UtilityPageContent` is covered.
 */
export const HiddenAnchorLinkBlock = (props: Props): React.JSX.Element => {
    return <span id={props.value} />;
};
